import config from "../config/app.conf.json";

export default (userId, orgId, roleIds, reason) => ({
  url: `${config.api.permissions_service_url}/users/${userId}/roles/assign`,
  method: "POST",
  data: { orgId, roleIds, reason}
});
